import { useState, useEffect } from 'react'
import parse from 'html-react-parser';
import styles from "./LeadCaptureOrder.module.css"
const LCProduct = ({ index, productItem, attachments, eventItem, updateProduct }) => {

    const [formData, setFormData] = useState(
        {
            id: null,
            name: null,
            description: null,
            regularPrice: null,
            onSitePrice: null,
            showQuantity: null,
            pdfAttachment: null,
            usePromoCode: null,
            promoCode: null,
            quantity: 0,
            selected: false,
            isAdmin: null,
            total: 0,
        }
    )

    const handleChange = (e) => {
        if (e.target.type === 'select-one') {
            setFormData({
                ...formData
            })
        }
        else if (e.target.type === 'checkbox') {
            formData[e.target.name] = e.target.checked;
            if (e.target.checked) {
                formData.quantity = 1;
            }
            else {
                formData.quantity = 0;
            }
            setFormData({
                ...formData
            })
        }
        else if (e.target.type === 'number') {
            formData[e.target.name] = parseInt( e.target.value);
            setFormData({
                ...formData
            })
            calculateTotal();
        }
        else {
            formData[e.target.name] = e.target.value;
            setFormData({
                ...formData
            })
        }
    }
    function base64ToBlob(base64Data, contentType = 'application/pdf') {
        const byteCharacters = atob(base64Data.split(',')[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: contentType });
    }
    function createObjectURLfromBase64(base64String, contentType) {
        const blob = base64ToBlob(base64String, contentType);
        return URL.createObjectURL(blob);
    }
    const calculateTotal = () => {
        let total = 0;
        let purchasePrice = 0;
        let startDate = new Date(eventItem.eventStartDate); //dd-mm-YYYY
        let today = new Date();
        if (startDate >= today) {
            // use regularPrice
            if (formData.quantity && formData.quantity !== undefined && formData.quantity > 0 &&
                formData.regularPrice && formData.regularPrice !== undefined && formData.regularPrice > 0) {
                purchasePrice = formData.regularPrice;
                total = formData.quantity * formData.regularPrice;
            }
        }
        else {
            // use onSitePrice
            if (formData.quantity && formData.quantity !== undefined && formData.quantity > 0 &&
                formData.onSitePrice && formData.onSitePrice !== undefined && formData.onSitePrice > 0) {
                purchasePrice = formData.onSitePrice;
                total = formData.quantity * formData.onSitePrice;
            }
           
        }
        if (total > 0) {
            formData.total = total;
            formData.purchasePrice = purchasePrice;
            setFormData({
                ...formData
            })
        }
        else {
            formData.total = 0;
            formData.purchasePrice = 0;
            setFormData({
                ...formData
            })
        }
    }
    const generatePDF = (attachment) => {
        var foundAttachment = attachments.find((item) => item.fileName === attachment);
        if (foundAttachment) {
            let newPDF = createObjectURLfromBase64(foundAttachment.attachmentBase64, foundAttachment.fileType);
            window.open(newPDF);
        }
        else {
            return null
        }

    }
    useEffect(() => {
        if (formData.total && formData.total !== undefined && formData.total > 0) {
            updateProduct(formData)
        }

    }, [formData.total])
    useEffect(() => {
        if (attachments && attachments.length > 0 && productItem.pdfAttachment && productItem.pdfAttachment !== undefined) {
            var foundAttachment = attachments.find((item) =>
                item.fileName.toLowerCase() === productItem.pdfAttachment.toLowerCase());
            if (foundAttachment) {
                productItem.attachment = foundAttachment;
                productItem.pdfAttachment = foundAttachment.fileName;
            }
            else {
                productItem.attachment = null;
                productItem.pdfAttachment = null;
            }
        }
        setFormData(productItem);
         
    }, [])
    return (
        <>
            {productItem.productGroups && ((productItem.productGroups=== 0) || ( productItem.productGroups % 2 === 1
                && productItem.productOrdering && productItem.productOrdering===1))? 
                <tr>
                    <td>
                        <div className={styles.progressBar}></div>
                    </td>
                    <td >
                        <div className={styles.progressBar}></div>
                    </td>
                    <td >
                        <div className={styles.progressBar}></div>
                    </td>
                    <td >
                        <div className={styles.progressBar}></div>
                    </td>
                    <td >
                        <div className={styles.progressBar}></div>
                    </td>
                    <td >
                        <div className={styles.progressBar}></div>
                    </td>
                </tr>
                : <></>
            }
            <tr className={styles.trProducts} >
                <td className={styles.tdProducts}>
                    <strong>{formData.name}</strong><br />
                    {formData.description ? parse(formData.description) :  <></>} 
                    {formData.pdfAttachment && formData.attachment ? <>
                        <br/>
                        <a title={formData.attachment.description} className={styles.pdfLink}
                            onClick={() => generatePDF(formData.pdfAttachment)}>For more information on {formData.attachment.displayName}</a>
                        <br />                        <br />
                        </>
                    :<></>}
                </td>
                <td className={styles.tdProducts}>
                    {formData.regularPrice}
                </td>
                <td className={styles.tdProducts}>
                    {formData.onSitePrice}
                </td>
                <td className={styles.tdProducts}>
                    {formData.usePromoCode && formData.usePromoCode !== undefined && formData.usePromoCode ? <input
                        tabIndex={10 + index}
                        type="number"
                        value={formData.promoCode}
                        name="promoCode"
                        onChange={handleChange}
                        className={styles.fitCell}
                    /> : "N/A"}
                </td>
                <td className={styles.tdProducts}>
                    {formData.showQuantity && formData.showQuantity !== undefined && formData.showQuantity ? <input
                        tabIndex={10 + index}
                        type="number"
                        value={formData.quantity}
                        name="quantity"
                        onChange={handleChange}
                        className={styles.fitCell}
                    /> : 
                        <input
                            tabIndex={10 + index}
                            type="checkbox"
                            checked={formData.selected}
                            name="selected"
                            onChange={handleChange}
                            className={styles.fitCell}
                        />
                }
                </td>
                <td className={styles.tdProducts}>
                    {formData.total ? '$' + formData.total.toLocaleString('en-US') : null}
                </td>
                
            </tr>
        </>
    );
}

export default LCProduct;